import React from 'react'
import { styles } from './styles'

interface JoinCircleProps {
  circlelabel: string
  color: string
  children: string
  customStyle?: string
}

const JoinCircle = ({
  circlelabel,
  color,
  children,
  customStyle,
}: JoinCircleProps) => {
  const classes = styles({ color })
  return (
    <div className={classes.wrapper}>
      <div className={`${classes.circle} ${customStyle}`}>
        <p className={classes.label}>{circlelabel}</p>
      </div>
      <p className={classes.text}>{children}</p>
    </div>
  )
}

export default JoinCircle
